/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

import AccountRegistrationPage from 'components/layouts/Preferences/AccountRegistration/AccountRegistrationPage';
import { accountRegistrationEnabled } from 'services/FeatureFlags';

const featureLinkConfig = {
  'profile/account-registration': {
    externalPath: null,
    featureEnabled: accountRegistrationEnabled(),
    internalComponent: AccountRegistrationPage,
    internalPath: '/profile/account-registration'
  }
};

export default featureLinkConfig;
